import { render, staticRenderFns } from "./ApmsBasicPlotInfo.vue?vue&type=template&id=dc55d86e&scoped=true&"
import script from "./ApmsBasicPlotInfo.vue?vue&type=script&lang=js&"
export * from "./ApmsBasicPlotInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc55d86e",
  null
  
)

export default component.exports